<template>
  <el-dialog title="修改店铺" :visible.sync="dialogVisible" width="70%" @close="refreshEditShopInfo">
    <el-form :model="editShopInfo" label-width="120px" ref="editShopForm">
      <el-form-item label="商铺名称" prop="shopName" required>
        <el-input v-model="editShopInfo.shopName" placeholder="必填，请填写商铺名称"></el-input>
      </el-form-item>

      <el-form-item label="商铺logo" prop="shopLogo" required>
        <upload-image-url ref="uploadImage" :imageCount="1"
          @notifyUploadCoverImage="handleUploadImage"></upload-image-url>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商铺类型" prop="shopType" required>
            <el-select v-model="editShopInfo.shopType" placeholder="必填，请选择商铺类型" @change="_changeEditShopType"
              style="width:100%">
              <el-option v-for="item in shopInfo.shopTypes" :key="item.shopTypeId" :label="item.typeName"
                :value="item.shopTypeId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开店类型" prop="openType" required>
            <el-select v-model="editShopInfo.openType" placeholder="必填，请选择开店类型" style="width:100%">
              <el-option v-for="item in editShopInfo.openTypes" :key="item.statusCd" :label="item.name"
                :value="item.statusCd"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="商铺描述" prop="shopDesc" required>
        <el-input type="textarea" v-model="editShopInfo.shopDesc" placeholder="必填，请填写商铺描述"></el-input>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="退货联系人" prop="returnPerson" required>
            <el-input v-model="editShopInfo.returnPerson" placeholder="必填，请填写退货联系人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退货联系电话" prop="returnLink" required>
            <el-input v-model="editShopInfo.returnLink" placeholder="必填，请填写退货联系电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="发货地址" prop="sendAddress" required>
            <el-input type="textarea" v-model="editShopInfo.sendAddress" placeholder="必填，请填写发货地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退货地址" prop="returnAddress" required>
            <el-input type="textarea" v-model="editShopInfo.returnAddress" placeholder="必填，请填写退货地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="坐标X位置" prop="mapX" required>
            <el-input v-model="editShopInfo.mapX" placeholder="请点击地图获取坐标" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="坐标Y位置" prop="mapY" required>
            <el-input v-model="editShopInfo.mapY" placeholder="请点击地图获取坐标" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="选择定位">
        <select-map-pos ref="selectMapPos" @position-change="handlePositionChange"></select-map-pos>
      </el-form-item>

      <el-form-item v-if="editShopInfo.state == '002'" label="修改原因" prop="applyOpinion" required>
        <el-input type="textarea" v-model="editShopInfo.applyOpinion" placeholder="必填，请填写修改原因"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="editShop">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateShop } from '@/api/shop/shopApi'
import { getDict } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'
import SelectMapPos from '@/components/system/selectMapPos'

export default {
  components: {
    UploadImageUrl,
    SelectMapPos
  },
  data() {
    return {
      dialogVisible: false,
      editShopInfo: {
        shopId: '',
        shopName: '',
        shopLogo: '2',
        shopType: '',
        openType: '',
        shopDesc: '',
        changeLogo: "",
        sendAddress: '',
        storeId: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        shopRange: '',
        shopRangeSel: [],
        shopRanges: [],
        openTypes: [],
        applyOpinion: '',
        mapX: '',
        mapY: '',
        state: '',
        areaCode: '',
      },
      shopInfo: {
        shopTypes: []
      },
      map: null
    }
  },
  methods: {
    open(shop) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.selectMapPos.initMap({})
        this.refreshEditShopInfo()
        this.getDictData()
        Object.assign(this.editShopInfo, shop)
        this.$refs.uploadImage.setImages([shop.shopLogo])
      })
    },
    async getDictData() {
      try {
        const { data } = await getDict('s_shop', 'open_type')
        this.editShopInfo.openTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handlePositionChange(position) {
      this.editShopInfo.mapX = position.lng
      this.editShopInfo.mapY = position.lat
    },
    handleUploadImage(param) {
      if (param.length > 0) {
        this.editShopInfo.shopLogo = param[param.length - 1]
      } else {
        this.editShopInfo.shopLogo = ''
      }
    },
    refreshEditShopInfo() {
      this.$refs.uploadImage.clearImages()
      this.editShopInfo = {
        shopId: '',
        shopName: '',
        applyOpinion: '',
        shopLogo: '2',
        storeId: '',
        changeLogo: '',
        shopType: '',
        openType: '',
        shopDesc: '',
        sendAddress: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        shopRange: '',
        shopRangeSel: [],
        shopRanges: [],
        openTypes: [],
        mapX: '',
        mapY: '',
        state: '',
        areaCode: '',
      }
    },
    _changeEditShopType() {
      console.log(this.editShopInfo.shopRangeSel)
      this.editShopInfo.shopRangeSel = []
    },
    async editShop() {
      try {
        const valid = await this.$refs.editShopForm.validate()
        if (!valid) return

        const res = await updateShop(this.editShopInfo)
        if (res.code === 0) {
          this.dialogVisible = false
          this.$emit('listShop')
          this.$message.success(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>